export default __webpack_public_path__ + "static/Image081-f852001346590e1ad32cd60a059af060.png";